import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Footer.css"; // Import custom styles
import { FaXTwitter } from "react-icons/fa6";
import { CIcon } from "@coreui/icons-react";
import { cibGlassdoor } from "@coreui/icons";
import { SiGlassdoor } from "react-icons/si";
import { FaLinkedin, FaFacebook, FaYoutube } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="footer-top">
          {/* Column 1 */}
          <Col xs={12} md={3}>
            <h5>What We Do</h5>
            <ul className="footer-links">
              <li>
                <a href="/gen-ai-banking">AI Banking</a>
              </li>
              <li>
                <a href="/enterprise-ai">Enterprise AI</a>
              </li>
              <li>
                <a href="/data-analytics">Data & Analytics</a>
              </li>
              <li>
                <a href="/next-gen-modernization">Next-Gen Modernization</a>
              </li>
              <li>
                <a href="/cloud-innovations">Cloud Innovations</a>
              </li>
              <li>
                <a href="/managed-cybersecurity">Managed Cybersecurity</a>
              </li>
            </ul>
          </Col>

          {/* Column 2 */}
          <Col xs={12} md={3}>
            <h5>Resources</h5>
            <ul className="footer-links">
              <li>
                <a href="/blog">Insights</a>
              </li>
              <li>
                <a href="/success-stories">Partner Story</a>
              </li>
              <li>
                <a href="/case-studies">Case Studies</a>
              </li>

              <li>
                <a href="/news-and-events">News & Events</a>
              </li>
              <li>
                <a href="/videos">Videos</a>
              </li>
              <li>
                <a href="/contract-vehicles">Contract Vehicles</a>
              </li>
            </ul>
          </Col>

          {/* Column 3 */}
          <Col xs={12} md={3}>
            <h5>Contact Us</h5>
            <ul className="footer-links-contact">
              <li>
                <b>Corporate Headquarters</b>
              </li>
              <li>
                Suite #10, 459 Herndon Pkwy,
                <br />
                Herndon, VA 20170
                <br />
                <a href="mailto:info@idexcel.com" className="footer-mail">
                  info@idexcel.com
                </a>
              </li>
            </ul>
          </Col>

          {/* Column 4 */}
          <Col xs={12} md={3}>
            <h5>Follow Us</h5>
            <div className="footer-social">
              <a
                href="https://www.linkedin.com/company/idexcel-inc"
                target="_blank"
                aria-label="LinkedIn"
              >
                <FaLinkedin />
              </a>
              <a
                href="https://x.com/idexcel"
                target="_blank"
                aria-label="Twitter"
              >
                <FaXTwitter />
              </a>
              <a
                href="https://www.facebook.com/idexcelinc"
                target="_blank"
                aria-label="Facebook"
              >
                <FaFacebook />
              </a>
              {/* <a href="#" aria-label="Glassdoor"><FaGlassdoor /></a> */}
              <a
                href="https://www.youtube.com/channel/UCaFMzzHjnfCaIM-3Uf8m5qQ"
                target="_blank"
                aria-label="YouTube"
              >
                <FaYoutube />
              </a>
              <a
                className="glassdoor-icon"
                href="https://www.glassdoor.co.in/Overview/Working-at-Idexcel-EI_IE388498.11,18.htm"
                target="_blank"
                aria-label="YouTube"
              >
                <SiGlassdoor size={30} color="#ccc" />
              </a>
            </div>
          </Col>
        </Row>

        {/* Horizontal Line */}
        <hr className="footer-divider" />

        {/* Bottom Section */}
        <Row className="footer-bottom">
          <Col xs={12} md={6} className="text-center text-md-start">
            © Copyright 2025 Idexcel, Inc. All Rights Reserved.
          </Col>
          <Col xs={12} md={6} className="text-center text-md-end">
            <a href="/privacy-policy">Privacy Policy</a> |{" "}
            <a href="/sitemap">Sitemap </a> |{" "}
            <a href="/contact-us">Contact Us</a>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
